import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUnclaimPermit = ({
  orderId,
  permitId,
  onSuccess,
  onError,
}: {
  orderId: string;
  permitId: string;
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: () => OrdersClient.unclaimPermit(orderId, permitId),
    onSuccess,
    onError,
  });

  return {
    unclaimPermit: mutate,
    isPending,
  };
};
